import React, { Fragment, useContext, useRef } from 'react'
import { Alert } from 'react-bootstrap';

import useTxSender from '../../hooks/useTxSender.js';
import useLog from "../../hooks/useLog.js"

import { Loader } from '../../components/Loader.js';
import { UserContext } from "../../Contexts/UserContext/UserContext.js";
import { Row } from "../../components/Row";
import { Spaces } from "../../components/Spaces";
import { TextDisplay } from "../../components/TextDisplay/TextDisplay";
import Bold from "../../components/Bold.js"
import SuccessTxSender from '../../components/SuccessTxSender.js';
import { default_func_jsx_fail, FaAlertIcon, FaInfoCircle } from '../../helpers/helpers.js';
import { confirmPopupHard } from '../../components/confirmPopup.js';



export default function Slide_Freeze(props) {
	const userContext = useContext(UserContext)
	const log = useLog("Slide_Freeze: ")

	// --- VARS ---

	const coinprops = userContext.get_selected_coin_props()
	const tokenID = coinprops.tokenid
	const tokenName = coinprops.name

	const tokenActionID = tokenID + "_freeze" // or mint_delphe ?
	const mess_default = "" //"Un récapitulatif des "+tokenName+" à minter va s'afficher ici"

	// state & refs
	const ref_messageEndRef = useRef(null) // for autoscroll

	const array_bool_user_inputs = []

	const token_balance = userContext.tokens_balance[tokenID]
	const bool_context_has_loaded = (token_balance != null) // && (context.bsvprice !=null)

	// --- FUNCTIONS ---

	async function func_empty_fields() { }

	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null

	const jsx_sending = <Fragment>
		Freeze du contrat en cours... &nbsp;
		<i className="reloadIcon fas fa-sync fa-spin" />
	</Fragment>

	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				Freeze du contrat effectué avec succès !
			</SuccessTxSender>
		)
	}

	// --- HOOK useTxSender ---

	const [
		bool_broadcast_lock,
		func_resetMess,
		dict_sendbutton_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
		)

	// --- FUNCTIONS ---

	const handleClick = async (event) => {
		event.preventDefault() // prevent redirection

		// don't allow parallel sends
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}

		const confirm_message = "⚠️ IRREVERSIBLE, ETES VOUS CERTAIN DE VOULOIR FREEZE LE CONTRAT ? ⚠️"
		const confirmed = await confirmPopupHard(confirm_message)
		if (!confirmed) return // abort

		// async but we don't want to await here !
		userContext.revokerContract_freeze()
	}

	// --- DISPLAY ---

	log("\n bool_broadcast_lock=", bool_broadcast_lock,)

	const revokerJig = userContext.revokerJig
	const revoker_owner = revokerJig ? revokerJig.owner : null
	const wallet_owner = userContext.address_owner
	const isRevokerOwner = revoker_owner === wallet_owner

	return (
		<div>

			<h1><i className="fas fa-shield-alt" /><Spaces count="3" />
				Freeze
			</h1><br />

			{isRevokerOwner ? null : <>
				<Alert variant="danger">
					<Bold>Vous ne semblez pas être l'administrateur de ce token.</Bold>
				</Alert><br />
			</>}

			<Alert variant="light">
				<FaInfoCircle />
				L'action Freeze bloque complètement le contrat (envoi & mixage de coins, mint,
				publication de mintuples et blacklist). Celle-ci peut servir par exemple pour
				freezer le contrat afin de ré-émettre les coins sur un nouveau protocole.
				Il reste possible de backup ou revoke même après un freeze.
			</Alert>

			<Alert variant="danger"><Bold>
				<FaAlertIcon />
				Attention cette action est NON-RÉVERSIBLE &nbsp;
				<FaAlertIcon />
			</Bold></Alert>

			<center>
				<div ref={ref_messageEndRef}>
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div><br />
			</center>

			<Row>
				<button style={dict_sendbutton_style} onClick={handleClick}
					id='submit_button' className="submitbutton">
					FREEZE
				</button>
			</Row>

		</div>
	)
}
